import { getPartOptionTypeCategory } from './partOptionFilters';

export const MCE_RECYCLED_NOTE = 'MCE recycled option is not valid.';
export const LKQ_NO_ADJUST_CALLOUT = "You're not allowed to adjust the list price of a recycled part.";

export function isLkqPartType(type: string | undefined): boolean {
    return getPartOptionTypeCategory(type ?? '') === 'LKQ';
}

export function canUsePartsTraderNoteDestination(args: {
    drpJob: boolean;
    source?: string;
}): boolean {
    return args.drpJob && args.source === 'partstrader';
}

export function requiresNonMceLkqNote(args: {
    partType?: string;
    drpJob: boolean;
    source?: string;
    insurerBest?: boolean;
}): boolean {
    return isLkqPartType(args.partType)
        && args.drpJob
        && args.source === 'partstrader'
        && args.insurerBest === false;
}

export type NoteDestination = 'marketplace' | 'estimating' | 'both';

export type NoteDrafts = {
    marketplace: string;
    estimating: string;
    both: string;
};

export function getInitialNoteDrafts(args: {
    marketplaceNote: string;
    estimatingNote: string;
    requiresNote: boolean;
}): NoteDrafts {
    const marketplaceBlank = !args.marketplaceNote.trim();
    return {
        marketplace: args.requiresNote && marketplaceBlank
            ? MCE_RECYCLED_NOTE
            : args.marketplaceNote,
        estimating: args.estimatingNote,
        both: '',
    };
}

/** Exact compare so clearing a note still counts as dirty. */
export function isNoteDraftDirty(draft: string, persisted: string): boolean {
    return draft !== persisted;
}
